export enum Role {
    PREST = "prest",
    PROST = "prost"
}
